
import { Component, Vue, Prop } from 'vue-property-decorator'
import { getWithdrawInfo } from '@/api/task/withdraw'
import { editOrderAttach, orderNotify } from '@/api/order/notify'
import { delObjEmptyKey, jsonToObjArr } from '@/utils'
import { notifiedStatus, upStreamStatusList } from '@/utils/constant'
import { AppModule } from '@/store/modules/app'
import PicsUploader from '@/components/PicsUploader/index.vue'
import { copyImgs } from '@/utils/clipboard'

@Component({
  name: 'orderDetail',
  components: {
    PicsUploader
  }
})
export default class extends Vue {
  @Prop({ required: true }) ordernumber!: number
  get language() {
    return AppModule.language
  }

  private close() {
    this.$emit('close')
  }

  private isPrint: boolean = false
  private clickPrint() {
    this.isPrint = true
    setTimeout(() => {
      this.isPrint = false
    }, 100)
  }
  private info: any = {}
  private tabName: string = 'orderInformation'
  private subTabName: string = 'Upstream'
  private loading: boolean = false

  private upstream_notify: any[] = []
  private upstream_request: any[] = []
  private upstream_response: any[] = []
  private notify_request: any[] = []
  private downstream_request: any[] = []
  private notify_response: any[] = []
  private orderTypeList = upStreamStatusList
  private notifiedStatus = notifiedStatus
  private callBackInfo: any = {}

  private setForm: any = {
    attach: []
  }
  private attachVisible = false

  private copyImg(item: string) {
    copyImgs(item)
  }

  // 上传图片
  private getPicList(fileList: any) {
    this.setForm.attach = fileList.map((item: any) => {
      if (item.response) {
        return item.response.file_path
      } else {
        return item.url
      }
    })
  }

  // 编辑 attach 弹窗
  private attachId: any = ''
  private attachUrl: any = []
  private attachEdit() {
    this.attachVisible = true
    this.attachId = this.ordernumber
    this.attachUrl = this.info.attach
  }

  // 编辑 attach
  private async editAttach() {
    try {
      this.loading = true
      let data: any = {
        ordernumber: this.attachId,
        attach: this.setForm.attach
      }
      await editOrderAttach(data).then((res: any) => {
        if (this.language === 'en') {
          this.$message.success('Edit success')
        }
        if (this.language === 'zh_cn') {
          this.$message.success('编辑成功')
        }
        if (this.language === 'zh_tw') {
          this.$message.success('編輯成功')
        }
        this.getWithdrawInfo()
        this.loading = false
        this.attachVisible = false
      })
    } catch (e) {
      this.loading = false
    }
  }

  private async getWithdrawInfo() {
    const data: any = {
      ordernumber: this.ordernumber
    }
    await getWithdrawInfo(data).then((res: any) => {
      this.info = res
      this.upstream_notify = jsonToObjArr(res.upstream_notify)
      this.upstream_request = jsonToObjArr(res.upstream_request)
      this.upstream_response = jsonToObjArr(res.upstream_response)
      this.downstream_request = jsonToObjArr(res.downstream_request)
      this.notify_request = jsonToObjArr(res.notify_request)
      this.notify_response = jsonToObjArr(res.notify_response)
      if (
        this.info.upstream_notify &&
        this.info.upstream_notify !== 'undefined'
      ) {
        this.callBackInfo = JSON.parse(this.info.upstream_notify.transfer_info)
      }
    })
  }
  private async notify(ordernumber: number) {
    await orderNotify({ ordernumber: ordernumber }).then(() => {
      this.$message({
        message: 'Notify successfully!',
        type: 'success'
      })
    })
  }

  private async init() {
    await this.getWithdrawInfo()
  }

  mounted() {
    this.init()
  }
}
